export const backCameraKeywords = [
	'rear',
	'back',
	'rück',
	'arrière',
	'trasera',
	'trás',
	'traseira',
	'posteriore',
	'后面',
	'後面',
	'背面',
	'后置',
	'後置',
	'背置',
	'задней',
	'الخلفية',
	'후',
	'arka',
	'achterzijde',
	'หลัง',
	'baksidan',
	'bagside',
	'sau',
	'bak',
	'tylny',
	'takakamera',
	'belakang',
	'אחורית',
	'πίσω',
	'spate',
	'hátsó',
	'zadní',
	'darrere',
	'zadná',
	'задня',
	'stražnja',
	'belakang',
	'बैक',
];

export const iosNonWideBackCameraLabels = [
	'Back Camera',
	'Rückkamera',
	'Caméra arrière',
	'Cámara trasera',
	'Câmera Traseira',
	'Câmara traseira',
	'Fotocamera (posteriore)',
	'后置相机',
	'後置相機',
	'背面カメラ',
	'Камера на задней панели',
	'Arka Kamera',
	'Camera aan achterzijde',
	'الكاميرا الخلفية',
	'กล้องด้านหลัง',
	'Kamera på baksidan',
	'Bagsidekamera',
	'Camera mặt sau',
	'Kamera bak',
	'Tylny aparat',
	'Takakamera',
	'Kamera Belakang',
	'מצלמה אחורית',
	'Πίσω κάμερα',
	'Cameră spate',
	'Hátsó kamera',
	'Zadní fotoaparát',
	'Càmera posterior',
	'Zadná kamera',
	'Задня камера',
	'Stražnja kamera',
	'Kamera Belakang',
	'बैक कैमरा',
];
